<template>
<div class="chapter">
<div class="inner_page">
<p class="fcenter2"><a id="page_iv"></a><a id="page_v"></a>For the women of Maui:</p>
<p class="fcenter">Ann Hood, Diane Lake, Annie LeClaire, Jacquelyn Mitchard, Deborah Todd, and Sara Young.</p>
<p class="fcenter1">And in loving memory of Heiman Zeidman.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?628823e8